import _Object$assign from "babel-runtime/core-js/object/assign";
import _slicedToArray from "babel-runtime/helpers/slicedToArray";
import _Promise from "babel-runtime/core-js/promise";
import _regeneratorRuntime from "babel-runtime/regenerator";
import _defineProperty from "babel-runtime/helpers/defineProperty";
import _asyncToGenerator from "babel-runtime/helpers/asyncToGenerator";

var _this2 = this;

import csdcService from "@/service/csdc-service";
import oppService from "@/service/opp-service";
import dict from "@/tools/dict";
import validateRules from "@/components/preEntry/validateRules";

var GROUP_ID = "";

var MODULE_ID = "";

var SAVE_PATH = "";

var backfillOldData = function backfillOldData(_this) {
  var trdAcctInfo = _.cloneDeepGet(_this, "oppBusiData.oldBusiData.trdAcctInfo");
  if (!_.isEmpty(trdAcctInfo)) {
    _this.$blMethod.parseGroupsMouduleData(_this, [MODULE_ID], trdAcctInfo);
  }
};

var backfillHistoryData = function backfillHistoryData(_this) {
  if (_this.userType == "2") {
    var fundInfo = _.cloneDeepGet(_this, "historyData.BIZ_DATA.OPEN_FUND_INFO", {});
    _this.groupDatas.ACCT_INFO.TRDACCT_MODULE[0].FIELDS.IS_OPEN_FINANCIAL_FUTURES.DEFAULT_VALUE = fundInfo.IS_OPEN_FINANCIAL_FUTURES;
    _this.groupDatas.ACCT_INFO.TRDACCT_MODULE[0].FIELDS.FINANCIAL_FUTURES_NUM.DEFAULT_VALUE = fundInfo.FINANCIAL_FUTURES_NUM;
    _this.groupDatas.ACCT_INFO.TRDACCT_MODULE[0].FIELDS.OA_NUM.DEFAULT_VALUE = fundInfo.OA_NUM;
  }
};

var myParseFloat = function myParseFloat(s) {
  var result = parseFloat(s);
  return isNaN(result) ? 0 : result;
};

var getCsdcChangeFlag = function () {
  var _ref = _asyncToGenerator(_regeneratorRuntime.mark(function _callee(_this, params) {
    var csdcData, changeCSDCData, isChangeCSDCFlag, name, value, key, changeKey;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            csdcData = {};
            changeCSDCData = _.get(params, "IMG_DATA.CHANGE_CSDC_INFO_LIST", []), isChangeCSDCFlag = _.get(params, "BIZ_DATA.IS_CHANGE_CSDC_FLAG", "0");

            if (!(_this.oppBusiData.ymtList && _this.oppBusiData.ymtList.length)) {
              _context.next = 7;
              break;
            }

            _context.next = 5;
            return csdcService.getCSDCTrdacctData({
              F_CUST_ORG_CODE: params.BIZ_DATA.ORG_CODE,
              YMT_CODE: _this.oppBusiData.ymtList[0].YMT_CODE,
              CUST_FNAME: params.BIZ_DATA.KEY_INFO.NEW_CUST_FNAME,
              CUST_NAME: params.BIZ_DATA.KEY_INFO.NEW_CUST_NAME,
              ID_TYPE: params.BIZ_DATA.KEY_INFO.NEW_ID_TYPE,
              ID_CODE: params.BIZ_DATA.KEY_INFO.NEW_ID_CODE,
              ACCTBIZ_EXCODE: "06",
              CHK_STATUS: "2",
              ACCTBIZ_CLS: "03",
              OPERATOR_TYPE: "0"
            }, true).catch(function (err) {
              consoleLog("获取中登数据失败csdcService.getCSDCTrdacctData");
              return [];
            });

          case 5:
            csdcData = _context.sent;

            csdcData = csdcData && csdcData[0] || {};

          case 7:

            if (!_.isEmpty(csdcData)) {
              changeCSDCData = [];
              isChangeCSDCFlag = "0";
              name = {
                ID_TYPE2: "组织机构证件类型",
                ID_CODE2: "组织机构证件号码",

                ID_EXP_DATE2: "组织机构证件有效期",
                MOBILE_TEL: "联系电话",
                ADDRESS: "联系地址",
                ID_ADDR: "证件地址",
                LEGAL_REP: "法定代表人姓名",
                LEGAL_REP_ID_TYPE: "法定代表人证件类型",
                LEGAL_REP_ID_CODE: "法定代表人证件号码",
                NATIONAL_ATTR: "国有属性",
                ORG_SIMPLE_NAME: "机构简称",
                ID_EXP_DATE: "主要身份证明文件证件有效期",
                LINKMAN: "联系人姓名",
                LINKMAN_ID_TYPE: "联系人证件类型",
                LINKMAN_ID_CODE: "联系人证件号码"
              };
              value = {
                ID_TYPE2: "1A",
                ID_CODE2: _.get(params, "BIZ_DATA.BASE_INFO.ORG_ID_CODE", ""),

                ID_EXP_DATE2: _this.groupDatas.OCR_ORG_INFO_PAGE.IMPORTANT_MODULE[0].FIELDS.ID_EXP_DATE.DEFAULT_VALUE,
                MOBILE_TEL: _this.groupDatas.OTHER_INFO_PAGE.LINK_MODULE[0].FIELDS.LINKMAN_TEL.DEFAULT_VALUE,
                ADDRESS: _this.groupDatas.ORG_INFO_PAGE.BASIC_MODULE[0].FIELDS.CORP_ADDR.DEFAULT_VALUE,
                ID_ADDR: _this.groupDatas.OCR_ORG_INFO_PAGE.IMPORTANT_MODULE[0].FIELDS.ID_ADDR.DEFAULT_VALUE,
                LEGAL_REP: _this.groupDatas.OTHER_INFO_PAGE.LEGAL_MODULE[0].FIELDS.LEGAL_REP.DEFAULT_VALUE,
                LEGAL_REP_ID_TYPE: _this.groupDatas.OTHER_INFO_PAGE.LEGAL_MODULE[0].FIELDS.LEGAL_REP_ID_TYPE.DEFAULT_VALUE,
                LEGAL_REP_ID_CODE: _this.groupDatas.OTHER_INFO_PAGE.LEGAL_MODULE[0].FIELDS.LEGAL_REP_ID_CODE.DEFAULT_VALUE,
                NATIONAL_ATTR: _this.groupDatas.ORG_INFO_PAGE.BASIC_MODULE[0].FIELDS.NATIONAL_ATTR.DEFAULT_VALUE,
                ORG_SIMPLE_NAME: _this.groupDatas.OCR_ORG_INFO_PAGE.IMPORTANT_MODULE[0].FIELDS.CUST_NAME.DEFAULT_VALUE,
                ID_EXP_DATE: _this.groupDatas.OCR_ORG_INFO_PAGE.IMPORTANT_MODULE[0].FIELDS.ID_EXP_DATE.DEFAULT_VALUE,
                LINKMAN: _this.groupDatas.OTHER_INFO_PAGE.LINK_MODULE[0].FIELDS.LINKMAN.DEFAULT_VALUE,
                LINKMAN_ID_TYPE: _this.groupDatas.OTHER_INFO_PAGE.LINK_MODULE[0].FIELDS.LINKMAN_ID_TYPE.DEFAULT_VALUE,
                LINKMAN_ID_CODE: _this.groupDatas.OTHER_INFO_PAGE.LINK_MODULE[0].FIELDS.LINKMAN_ID.DEFAULT_VALUE };

              if (csdcData.ID_CODE) {
                for (key in name) {
                  if (key === "NATIONAL_ATTR" && csdcData[key] === "") {
                    csdcData[key] = "4";
                  }
                  if (value[key] != csdcData[key]) {
                    if (key === "ID_TYPE2" || key === "ID_CODE2") {
                      changeKey = "NEW_" + key;

                      changeCSDCData.push({
                        key: changeKey,
                        name: name[key],
                        value: {
                          change: value[key],
                          init: csdcData[key].trim() || "空"
                        },
                        changeValue: _defineProperty({}, changeKey, value[key])
                      });
                    } else {
                      changeCSDCData.push({
                        key: key,
                        name: name[key],
                        value: {
                          change: value[key],
                          init: csdcData[key].trim() || "空"
                        },
                        changeValue: _defineProperty({}, key, value[key])
                      });
                    }
                    isChangeCSDCFlag = "1";
                  }
                }
              }
            }
            return _context.abrupt("return", {
              changeCSDCData: changeCSDCData,
              isChangeCSDCFlag: isChangeCSDCFlag
            });

          case 9:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, _this2);
  }));

  return function getCsdcChangeFlag(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

var initFieldConfig = function initFieldConfig(_this) {
  var fields = _this.groupDatas[GROUP_ID][MODULE_ID][0].FIELDS;
  _this.groupDatas.ACCT_INFO.TRDACCT_MODULE[0].FIELDS.TRDACCT_INFOA.FIELD_TYPE = "openBizStock";
  _this.groupDatas.ACCT_INFO.TRDACCT_MODULE[0].FIELDS.TRDACCT_INFOA.showAllStock = true;
  _this.groupDatas.ACCT_INFO.TRDACCT_MODULE[0].FIELDS.TRDACCT_INFOB.FIELD_TYPE = "openBizStock";
  _this.groupDatas.ACCT_INFO.TRDACCT_MODULE[0].FIELDS.TRDACCT_INFOB.FIELD_CONTROL = "1";

  if (_this.userType == "2") {
    fields.FINANCIAL_FUTURES_NUM.VALID_TYPE = "length[0,20]";
  }
};

var queryCSDC = function queryCSDC(_this, clickQuery) {
  var marketInfo = {
    "SZSZ": {
      OLD_ACCT_TYPE: "21",
      MARKET_NAME: "深A股东账户",
      MARKET_NAME_SHORT: "深A",
      STKBD: "00",
      stkCode: "SzA",
      OPEN_TYPE: "0",
      OP_TYPE: "SZA" },
    "SSZ": {
      OLD_ACCT_TYPE: "11",
      MARKET_NAME: "沪A股东账户",
      MARKET_NAME_SHORT: "沪A",
      STKBD: "10",
      stkCode: "ShA",
      OPEN_TYPE: "0",
      OP_TYPE: "SHA"
    },
    "SZSZ_FUND": {
      OLD_ACCT_TYPE: "23",
      MARKET_NAME: "深圳基金账户",
      MARKET_NAME_SHORT: "深基金",
      STKBD: "00",
      stkCode: "SzJj",
      OPEN_TYPE: "1",
      OP_TYPE: "SZFUNDS"
    },
    "SSZ_FUND": {
      OLD_ACCT_TYPE: "13",
      MARKET_NAME: "上海基金账户",
      MARKET_NAME_SHORT: "沪基金",
      STKBD: "10",
      stkCode: "ShJj",
      OPEN_TYPE: "1",
      OP_TYPE: "SHFUNDS"
    },
    "SzB": {
      OLD_ACCT_TYPE: "22",
      MARKET_NAME: "深B股东账户",
      MARKET_NAME_SHORT: "深B",
      STKBD: "01",
      stkCode: "SzB",
      OPEN_TYPE: "2",
      OP_TYPE: "SZB"
    },
    "ShB": {
      OLD_ACCT_TYPE: "12",
      MARKET_NAME: "沪B股东账户",
      MARKET_NAME_SHORT: "沪B",
      STKBD: "11",
      stkCode: "ShB",
      OPEN_TYPE: "2",
      OP_TYPE: "SHB"
    },
    "AG": {
      OLD_ACCT_TYPE: "AG",
      MARKET_NAME: "",
      MARKET_NAME_SHORT: "",
      STKBD: "10",
      OP_TYPE: "AG"
    },
    "H8": {
      OLD_ACCT_TYPE: "H8",
      MARKET_NAME: "",
      MARKET_NAME_SHORT: "",
      STKBD: "00",
      OP_TYPE: "H8"
    },
    "HO": {
      OLD_ACCT_TYPE: "HO",
      MARKET_NAME: "",
      MARKET_NAME_SHORT: "",
      STKBD: "01",
      OP_TYPE: "HO"
    }
  };
  var custInfo = _this.$storage.getJsonSession(_this.$definecfg.CUSTOMER_INFO) || {},
      initProCls = _.get(_this, "groupDatas.PRODUCT_INFO_PAGE.BASE_INFO[0].FIELDS.PRO_CLS.DEFAULT_VALUE") || "",
      proCls = initProCls ? initProCls.slice(0, 2) : "";

  var SZ_STKPBU = (oppService.getBusiCommonParamsFromCacheObjs("SZ_STKPBU") || "").split("|") || "",
      SH_STKPBU = (oppService.getBusiCommonParamsFromCacheObjs("SH_STKPBU") || "").split("|") || "";

  _this.disabledArray.length == 0 && _this.$store.commit(_this.$types.UPDATE_LOADING, "正在查询中登数据...");

  var onlyCheck = _this.noUpdateApptStatus.includes(_this.apptStatus);

  return _Promise.all([!onlyCheck && _this.oppBusiData.isCsdcTime == "true" ? csdcService.getCSDCAcctData(_this, custInfo.CUST_FNAME, custInfo.ID_TYPE, custInfo.ID_CODE, custInfo.CUST_NAME) : [], !onlyCheck && _this.oppBusiData.isCsdcTime == "true" ? csdcService.getCSDCYmtData(_this, custInfo.CUST_FNAME, custInfo.ID_TYPE, custInfo.ID_CODE, custInfo.CUST_NAME) : []]).then(function (_ref2) {
    var _ref3 = _slicedToArray(_ref2, 2),
        res1 = _ref3[0],
        res2 = _ref3[1];

    _this.oppBusiData.ymtList = _.filter(res2, function (item) {
      return item.YMT_STATUS == "0";
    });
    if (_this.oppBusiData.ymtList.length > 1) {
      _this.pushFlowTip({
        title: "（仅提示，可以继续办理业务）：该客户存在多个一码通账户，请在预受理提交后，对客户的一码通账户进行规范。",
        key: "multiymt",
        type: "warning"
      });
    }
    var ymt_code = _.get(_this, "oppBusiData.ymtList[0].YMT_CODE") || _.get(_this, "historyData.BIZ_DATA.YMT_CODE");

    _this.oppBusiData.csdcTrdacctArr = res1.filter(function (v) {
      return v.ACCT_STATUS == "0" && v.YMT_CODE == ymt_code;
    });
    if (_this.disabledArray.length == 0 && clickQuery && _this.oppBusiData.isCsdcTime == "true" && !res1.length) {
      alert("无中登数据！");
    }

    _.each(_this.oppBusiData.csdcTrdacctArr, function (info) {
      if (_this.oppBusiData.SPECIAL_ACCT_TYPE.includes(info.ACCT_TYPE)) {
        if (["AG", "H8", "HO"].indexOf(info.ACCT_TYPE) == -1) {
          marketInfo[info.ACCT_TYPE] = {
            OLD_ACCT_TYPE: info.ACCT_TYPE,
            MARKET_NAME: "",
            MARKET_NAME_SHORT: _this.oppBusiData.accTypeObj[info.ACCT_TYPE],
            STKBD: ["A", "B"].indexOf(info.ACCT_TYPE.substring(0, 1)) > -1 ? "10" : "00",
            OP_TYPE: info.ACCT_TYPE
          };
        } else {
          marketInfo[info.ACCT_TYPE].canShowItem = true;
          marketInfo[info.ACCT_TYPE].isDisableAddStock = true;
        }
      }
    });

    if (_this.groupDatas.ACCT_INFO.TRDACCT_MODULE[0].FIELDS.TRDACCT_INFOA.FIELD_DICT == "APPT_OPEN_ACCT") {
      var trdacctInfoDict = [];

      var _loop = function _loop(key) {
        if (!_this.oppBusiData.isAllowOpenB && ["12", "22"].includes(marketInfo[key].OLD_ACCT_TYPE)) {
          return "continue";
        }
        if (!_this.oppBusiData.isAllowOpenA && ["11", "21"].includes(marketInfo[key].OLD_ACCT_TYPE)) {
          return "continue";
        }

        if (["13", "23"].includes(marketInfo[key].OLD_ACCT_TYPE) && (custInfo.ID_TYPE == "14" || _this.openAcctType == 3 || _this.oppBusiData.RISK_FACTOR.includes("o"))) {
          return "continue";
        }

        var oldAccountKey = key + "Data",
            checkTrdacct = _this.oppBusiData.checkTrdacctObj["_" + marketInfo[key].OLD_ACCT_TYPE] || {
          SEL_TYPE: "",
          TRDACCT: ""
        };
        var trdacctList = [];
        trdacctList = _.chain(_this.oppBusiData.csdcTrdacctArr).filter(function (item) {
          return item.ACCT_TYPE == marketInfo[key].OLD_ACCT_TYPE;
        }).map(function (item) {
          item.DICT_ITEM = item.TRDACCT;
          item.DICT_ITEM_NAME = item.TRDACCT;
          item.DICT_ITEM_html = item.TRDACCT;
          item.IS_DISABLE = item.ACCT_STATUS !== "0";
          return item;
        }).value();
        var stkpbu = "";

        if (["23", "23a", "23b", "23c", "23d", "23e", "23f"].includes(initProCls)) {
          if (marketInfo[key].STKBD == "10") {
            stkpbu = "沪A交易单元-" + SH_STKPBU[0];
          } else {
            stkpbu = "深A交易单元-" + SZ_STKPBU[0];
          }
        } else if (["01"].includes(initProCls)) {
          if (marketInfo[key].STKBD == "10") {
            stkpbu = "沪A交易单元-" + SH_STKPBU[1];
          } else {
            stkpbu = "深A交易单元-" + SZ_STKPBU[1];
          }
        } else if (["99b", "99c"].includes(initProCls)) {
          stkpbu = checkTrdacct.STKPBU || "";
        }

        var newAddDisable = false;
        if (_this.oppBusiData.SZORGTYPE != "99b") {
          if (_this.oppBusiData.SPECIAL_ACCT_TYPE.includes(marketInfo[key].OLD_ACCT_TYPE)) {
            newAddDisable = true;
          }

          if (["AG", "H8", "HO"].indexOf(marketInfo[key].OLD_ACCT_TYPE) > -1 && !marketInfo[key].canShowItem) {
            return "continue";
          }
        } else {
          if (_this.oppBusiData.SPECIAL_ACCT_TYPE.includes(marketInfo[key].OLD_ACCT_TYPE)) {
            if (_this.userType == "1" && ["AG", "H8", "HO"].indexOf(marketInfo[key].OLD_ACCT_TYPE) == -1) {
              newAddDisable = true;
            }

            if (_this.userType == "2") {
              newAddDisable = true;
            }
          }
        }
        if (_this.oppBusiData.specialOrg) {
          newAddDisable = true;
        }

        var tempArr = trdacctList;
        var trdAcct = checkTrdacct.TRDACCT;

        if (!onlyCheck && _this.oppBusiData.isCsdcTime == "true") {
          tempArr = _.filter(trdacctList, function (v) {
            return v.TRDACCT == checkTrdacct.TRDACCT;
          });
          trdAcct = tempArr.length ? checkTrdacct.TRDACCT : "";
        }
        trdacctInfoDict.push(_Object$assign({}, marketInfo[key], {
          DICT_ITEM: marketInfo[key].OLD_ACCT_TYPE,
          DICT_ITEM_NAME: ["AG", "H8", "HO"].includes(marketInfo[key].OLD_ACCT_TYPE) ? _this.oppBusiData.accTypeObj[key] : marketInfo[key].MARKET_NAME_SHORT,
          stockEnable: true,
          newAddDisable: newAddDisable ? true : false,
          TRDACCT_LIST: trdacctList,
          SEL_TYPE: checkTrdacct.SEL_TYPE || "",
          TRDACCT: trdAcct,
          stkpbuDisabled: ["99b", "99c"].includes(initProCls) ? false : true,
          STKPBU: stkpbu,
          IS_DISABLE: _this.oppBusiData.isDisableAllStock,
          isDisableAddStock: ["AG", "H8", "HO"].includes(marketInfo[key].OLD_ACCT_TYPE) ? true : false
        }));
      };

      for (var key in marketInfo) {
        var _ret = _loop(key);

        if (_ret === "continue") continue;
      }
      if (clickQuery) {
        _.each(_this.groupDatas.ACCT_INFO.TRDACCT_MODULE[0].FIELDS.TRDACCT_INFOA.FIELD_DICT_NAME, function (item) {
          var obj = _.find(trdacctInfoDict, function (obj) {
            return obj.DICT_ITEM == item.DICT_ITEM;
          });
          if (obj) {
            item.TRDACCT_LIST = obj.TRDACCT_LIST;
          }
        });
      } else {
        _this.groupDatas.ACCT_INFO.TRDACCT_MODULE[0].FIELDS.TRDACCT_INFOA.FIELD_DICT_NAME = trdacctInfoDict;
      }
      !onlyCheck && _this.$store.commit(_this.$types.UPDATE_LOADING, false);
    }
  });
};
var getRelationshipNotConfirmArr = function getRelationshipNotConfirmArr(trdacctArr, isFilterUnqualiFlag) {
  var pt1 = /^F97[\w]+$/,
      pt2 = /^F[5-9]{1}[\w]+$/,
      pt3 = /^05[\w]+$/,
      trdAcctList = [];


  isFilterUnqualiFlag = isFilterUnqualiFlag || "1";

  trdAcctList = trdacctArr.filter(function (v) {
    var flag = "1" === v.RELATION_FLAG || _.includes(["14", "15", "24", "25", "13", "23"], v.ACCT_TYPE);

    "1" === isFilterUnqualiFlag && (flag = flag || "1" === v.UNQUALI_FLAG);
    return !flag && _.indexOf(["0", "5", "6"], v.ACCT_STATUS) > -1;
  });

  return trdAcctList || [];
};
var showAcctSpecialOpenTip = function showAcctSpecialOpenTip(_this) {
  if (_this.openAcctType == "2" || _this.openAcctType === "3") {
    var hasNewOpen = !_.isEmpty(_.filter(_this.oppBusiData.checkTrdacctObj, function (value, key) {
      return value.hasSave == "1" && value.SEL_TYPE == "1";
    }));
    if (hasNewOpen) {
      _this.pushFlowTip({
        title: "我司将会根据您的留存信息在PROP平台为您开立中登证券账户",
        key: "showAcctSpecialOpenTip",
        type: "warning"
      });
    } else {
      _this.removeFlowTip("showAcctSpecialOpenTip");
    }
  }
};

var saveTrdacctObj = function saveTrdacctObj(_this, newStockInfo) {
  _this.oppBusiData.checkTrdacctObj["_" + newStockInfo.value] = {
    TRDACCT_INFO: newStockInfo.value,
    SEL_TYPE: newStockInfo.SEL_TYPE,
    TRDACCT: newStockInfo.TRDACCT,
    hasSave: "1",
    STKPBU: newStockInfo.STKPBU
  };
};

var removeTrdacctObj = function removeTrdacctObj(_this, newStockInfo) {
  if (_this.oppBusiData.checkTrdacctObj["_" + newStockInfo.value]) delete _this.oppBusiData.checkTrdacctObj["_" + newStockInfo.value];
};

var validateNewOpen = function () {
  var _ref4 = _asyncToGenerator(_regeneratorRuntime.mark(function _callee2(_this, newStockInfo, str, isValidate) {
    var maxTrdANum, maxTrdBNum, maxNum, acctType, stockNode, list;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return oppService.getSysCommonParamsFromCacheObjs("A_MARKET_TRDACCT_COUNT_LIMIT");

          case 2:
            _context2.t0 = _context2.sent;

            if (_context2.t0) {
              _context2.next = 5;
              break;
            }

            _context2.t0 = 3;

          case 5:
            maxTrdANum = _context2.t0;
            _context2.next = 8;
            return oppService.getSysCommonParamsFromCacheObjs("B_MARKET_TRDACCT_COUNT_LIMIT");

          case 8:
            _context2.t1 = _context2.sent;

            if (_context2.t1) {
              _context2.next = 11;
              break;
            }

            _context2.t1 = 3;

          case 11:
            maxTrdBNum = _context2.t1;
            maxNum = !["12", "22"].includes(newStockInfo.value) ? maxTrdANum : maxTrdBNum, acctType = newStockInfo.value, stockNode = _this.oppBusiData.stockNode;
            list = _.filter(_this.oppBusiData.csdcTrdacctArr, function (v) {
              return v.ACCT_TYPE == (newStockInfo.value || newStockInfo.OLD_ACCT_TYPE) && v.ACCT_STATUS != "9";
            }) || [];

            if (!(list.length >= maxNum && newStockInfo.SEL_TYPE == "1" && !_this.oppBusiData.RISK_FACTOR.includes("o"))) {
              _context2.next = 17;
              break;
            }

            _this.alert("客户在中登有效的" + str + "市场账户数量已达" + maxNum + "个，不允许再新开！");
            return _context2.abrupt("return", false);

          case 17:
            if (!(_this.openAcctType == 1 && list.length)) {
              _context2.next = 21;
              break;
            }

            if (!getRelationshipNotConfirmArr(list).length) {
              _context2.next = 21;
              break;
            }

            _this.alert("账户状态为：正常、禁买、禁卖的合格账户且关联关系未确认不能新开证券账户！");
            return _context2.abrupt("return", false);

          case 21:

            if ((_this.openAcctType == "2" || _this.openAcctType === "3") && !isValidate) {
              _this.pushFlowTip({
                title: "请告知客户，券商会根据客户柜台留存信息在PROP平台为其开立中登证券账户！",
                key: "proptrd",
                type: "warning"
              });
            }
            return _context2.abrupt("return", true);

          case 23:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, this);
  }));

  return function validateNewOpen(_x3, _x4, _x5, _x6) {
    return _ref4.apply(this, arguments);
  };
}();

var getTrdAcctInfo = function getTrdAcctInfo(_this) {
  var trdAcctInfoArr = [],
      initProCls = _this.userType == "2" ? _this.groupDatas.PRODUCT_INFO_PAGE.BASE_INFO[0].FIELDS.PRO_CLS.DEFAULT_VALUE : "",
      proCls = initProCls ? initProCls.slice(0, 2) : "";

  var SZ_STKPBU = (oppService.getBusiCommonParamsFromCacheObjs("SZ_STKPBU") || "").split("|") || "",
      SH_STKPBU = (oppService.getBusiCommonParamsFromCacheObjs("SH_STKPBU") || "").split("|") || "";

  var _loop2 = function _loop2(key) {
    if (_this.oppBusiData.checkTrdacctObj[key].hasSave == "1") {
      var _stkpbu = "";
      var trdacctInfo = _.find(_this.groupDatas.ACCT_INFO.TRDACCT_MODULE[0].FIELDS.TRDACCT_INFOA.FIELD_DICT_NAME, function (v) {
        return v.DICT_ITEM == _this.oppBusiData.checkTrdacctObj[key].TRDACCT_INFO;
      });

      if (_.isEmpty(trdacctInfo)) {
        return "continue";
      }

      if (["23"].includes(proCls)) {
        if (trdacctInfo.STKBD == "10") {
          _stkpbu = SH_STKPBU[0];
        } else {
          _stkpbu = SZ_STKPBU[0];
        }
      } else if (["01"].includes(initProCls)) {
        if (trdacctInfo.STKBD == "10") {
          _stkpbu = SH_STKPBU[1];
        } else {
          _stkpbu = SZ_STKPBU[1];
        }
      } else if (["99c", "99b"].includes(initProCls)) {
        _stkpbu = trdacctInfo.STKPBU;
      }

      var speciaObj = {};

      if (_this.oppBusiData.SPECIAL_ACCT_TYPE.includes(trdacctInfo.DICT_ITEM)) {
        speciaObj.TRDACCT_EXCLS = _this.oppBusiData.acctTypeAndExcls[trdacctInfo.DICT_ITEM];
        speciaObj.TRDACCT_EXCLS_TEXT = _this.oppBusiData.accTypeObj[trdacctInfo.DICT_ITEM];
        speciaObj.OPEN_TYPE = ["HN", "HO"].includes(trdacctInfo.DICT_ITEM) ? "2" : "0";
      }
      trdAcctInfoArr.push(_Object$assign({
        OPEN_TYPE: trdacctInfo.OPEN_TYPE,
        STKBD: trdacctInfo.STKBD,
        TRDACCT: trdacctInfo.TRDACCT,
        SEL_TYPE: trdacctInfo.SEL_TYPE,
        OP_TYPE: "$" + trdacctInfo.OP_TYPE,
        ACCT_TYPE: trdacctInfo.DICT_ITEM,
        STKPBU: _stkpbu
      }, speciaObj));
    }
  };

  for (var key in _this.oppBusiData.checkTrdacctObj) {
    var _ret2 = _loop2(key);

    if (_ret2 === "continue") continue;
  }
  return trdAcctInfoArr;
};
var isAllowOpenAcctSpecialOrg = function isAllowOpenAcctSpecialOrg(_this) {
  var SZORGTYPE = "";
  if (_this.userType == "1") {
    SZORGTYPE = _this.groupDatas.ORG_INFO_PAGE.BASIC_MODULE[0].FIELDS.SZORG_TYPE.DEFAULT_VALUE;
  } else {
    SZORGTYPE = _this.groupDatas.MANAGER_INFO_PAGE.MANAGER_OTHER_INFO[0].FIELDS.SZORG_TYPE.DEFAULT_VALUE;
  }
  var subjectIdentityArr = ["6", "c"],
      customerInfo = _this.$storage.getJsonSession(_this.$definecfg.CUSTOMER_INFO),
      subjectIdentity = customerInfo.SUBJECT_IDENTITY,
      szOrgTypeArr = ["10", "11", "12", "13", "14", "33", "34", "41", "99a", "99b"],
      szOrgType = SZORGTYPE;
  return szOrgTypeArr.includes(szOrgType) || subjectIdentityArr.includes(subjectIdentity);
};

var getTrdUpdateFlag = function getTrdUpdateFlag(oldTrdacctInfoList, newTrdInfoList) {
  var flag = false;
  if (!oldTrdacctInfoList.length && newTrdInfoList.length) {
    return true;
  }
  for (var i = 0; i < newTrdInfoList.length; i++) {
    var newObj = newTrdInfoList[i];
    for (var j = 0; j < oldTrdacctInfoList.length; j++) {
      var oldObj = oldTrdacctInfoList[j];
      if (newObj.SEL_TYPE != oldObj.SEL_TYPE || newObj.TRDACCT != oldObj.TRDACCT) {
        flag = true;
        break;
      }
    }
    if (flag) {
      break;
    }
  }
  return flag;
};
var NODE = {
  getGroupId: function getGroupId() {
    return GROUP_ID;
  },

  getModuleId: function getModuleId() {
    return MODULE_ID;
  },

  init: function init(_this) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    GROUP_ID = params.groupId;
    MODULE_ID = params.moduleId;
    SAVE_PATH = params.savePath;
  },

  beforeLoadBiz: function beforeLoadBiz(_this) {
    var custInfo = _this.$storage.getJsonSession(_this.$definecfg.CUSTOMER_INFO) || {};
    return _Promise.all([csdcService.queryCSDCTime(), oppService.getSysCommonParamsFromCacheObjs("MECHANISM_PRO_INVESTORS_I"), oppService.getSysCommonParamsFromCacheObjs("ENABLE_OPEN_ACCT_MATCH_RESULT"), dict.getDictData("ACCT_TYPE_EXCLS"), oppService.getSysCommonParamsFromCacheObjs("SPECIAL_ACCT_TYPE")]).then(function (_ref5) {
      var _ref6 = _slicedToArray(_ref5, 5),
          res1 = _ref6[0],
          MECHANISM_PRO_INVESTORS_I = _ref6[1],
          ENABLE_OPEN_ACCT_MATCH_RESULT = _ref6[2],
          res4 = _ref6[3],
          SPECIAL_ACCT_TYPE = _ref6[4];

      _this.oppBusiData.isCsdcTime = res1;
      var ACCT_TYPE_EXCLS_LIST = res4.ACCT_TYPE_EXCLS;
      _this.oppBusiData.MECHANISM_PRO_INVESTORS_I = MECHANISM_PRO_INVESTORS_I.split(",");
      _this.oppBusiData.ENABLE_OPEN_ACCT_MATCH_RESULT = ENABLE_OPEN_ACCT_MATCH_RESULT;
      _this.oppBusiData.SPECIAL_ACCT_TYPE = SPECIAL_ACCT_TYPE;
      initFieldConfig(_this);

      _this.$set(_this.groupDatas.ACCT_INFO.TRDACCT_MODULE[0].FIELDS.TRDACCT_INFOA, "ALLOW_INPUT_STKPBU", "0");
      if (_this.$storage.getJsonSession(_this.$definecfg.IS_OPEN_ACCT_BIZ) == 0) {
        backfillOldData(_this);
      }
      _this.oppBusiData.accTypeObj = {};
      _this.oppBusiData.acctTypeAndExcls = {};
      ACCT_TYPE_EXCLS_LIST.forEach(function (v, i) {
        var dictName = v.DICT_ITEM_NAME.split("-");
        if (v.DICT_ITEM === "H8") {
          var dictH8 = dictName[0].split("/");
          dictName[0] = dictH8[1];
        }
        _this.oppBusiData.accTypeObj[v.DICT_ITEM] = dictName[1];
        _this.oppBusiData.acctTypeAndExcls[v.DICT_ITEM] = dictName[0];
      });

      _this.groupDatas.ACCT_INFO.TRDACCT_MODULE[0].MODULE_QUERY = "1";
      if (_this.userType == "2") {
        _this.groupDatas.ACCT_INFO.TRDACCT_MODULE[0].FIELDS.IS_OPEN_FINANCIAL_FUTURES.FIELD_REQUIRED = "1";
      }
    });
  },

  afterLoadBiz: function afterLoadBiz(_this) {
    backfillHistoryData(_this);
  },
  preValidate: function preValidate(_this) {
    _this.removeFlowTip("showAcctSpecialOpenTip");
    _this.removeFlowTip("multiymt");
    _this.removeFlowTip("proptrd");
    _this.removeFlowTip("allowB");
    _this.removeFlowTip("forbinOpen");
    _this.removeFlowTip("bizSuryRisk");
  },
  beforeSave: function () {
    var _ref7 = _asyncToGenerator(_regeneratorRuntime.mark(function _callee3(_this, params, baseData) {
      var specialTypeArr, SZORGTYPE, trdAcctInfo, szStkpbuVal, shStkpbuVal, TRDACCT_INFO_LIST, oldTrdacctInfoList, flag, YMT_CODE, csdcData;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _this.removeFlowTip("showAcctSpecialOpenTip");
              _this.removeFlowTip("multiymt");
              _this.removeFlowTip("proptrd");
              _this.removeFlowTip("allowB");
              _this.removeFlowTip("forbinOpen");
              _this.removeFlowTip("bizSuryRisk");

              specialTypeArr = ["15", "51", "52", "99a", "99b", "10", "11", "12", "13", "14", "33", "34", "41"];
              SZORGTYPE = "";

              if (_this.userType == "1") {
                SZORGTYPE = _this.groupDatas.ORG_INFO_PAGE.BASIC_MODULE[0].FIELDS.SZORG_TYPE.DEFAULT_VALUE;
              } else {
                SZORGTYPE = _this.groupDatas.MANAGER_INFO_PAGE.MANAGER_OTHER_INFO[0].FIELDS.SZORG_TYPE.DEFAULT_VALUE;
              }
              trdAcctInfo = { OPEN_TYPE: "0", TRDACCT: "", STKBD: "", SEL_TYPE: "", OP_TYPE: "", SETT_MODE: "", STKPBU: "", ZD_OPEN_DATE: "", TRDACCT_EXCLS: "" }, szStkpbuVal = void 0, shStkpbuVal = void 0;

              params.DETAIL_DATA.checkTrdacctObj = _this.oppBusiData.checkTrdacctObj;
              TRDACCT_INFO_LIST = getTrdAcctInfo(_this);

              TRDACCT_INFO_LIST.map(function (v) {
                if (["00", "01"].includes(v.STKBD)) {
                  szStkpbuVal = v.STKPBU;
                } else {
                  shStkpbuVal = v.STKPBU;
                }
              });
              oldTrdacctInfoList = _.get(_this, "historyData.BIZ_DATA.TRDACCT_INFO_LIST") || [];

              if (_this.apptStatus >= 4) {
                flag = getTrdUpdateFlag(oldTrdacctInfoList, TRDACCT_INFO_LIST);

                params.DETAIL_DATA.TRDACCT_INFO_LIST_UPDATE_FLAG = flag ? "1" : "0";
              }

              YMT_CODE = _.get(_this, "oppBusiData.ymtList[0].YMT_CODE") || _.get(params, "BIZ_DATA.YMT_CODE") || "";

              params.YMT_CODE = YMT_CODE;
              params.BIZ_DATA.YMT_CODE = YMT_CODE || "";
              params.BIZ_DATA.SZ_STKPBU = szStkpbuVal;
              params.BIZ_DATA.SH_STKPBU = shStkpbuVal;
              params.BIZ_DATA.isAllowOpenAcctSpecialOrg = isAllowOpenAcctSpecialOrg(_this) ? "1" : "0";
              params.BIZ_DATA.SPECIAL_TYPE_FLAG = specialTypeArr.includes(SZORGTYPE) ? "1" : "0";
              if (_this.userType == "2") {
                params.BIZ_DATA.OPEN_FUND_INFO = {
                  IS_OPEN_FINANCIAL_FUTURES: _this.groupDatas.ACCT_INFO.TRDACCT_MODULE[0].FIELDS.IS_OPEN_FINANCIAL_FUTURES.DEFAULT_VALUE,

                  FINANCIAL_FUTURES_NUM: _this.groupDatas.ACCT_INFO.TRDACCT_MODULE[0].FIELDS.FINANCIAL_FUTURES_NUM.DEFAULT_VALUE,
                  OA_NUM: _this.groupDatas.ACCT_INFO.TRDACCT_MODULE[0].FIELDS.OA_NUM.DEFAULT_VALUE
                };
              }

              if (_this.userType == "2" && _.isEmpty(TRDACCT_INFO_LIST)) {
                params.IMG_DATA.AGMT_TYPE_IMG = "";
                _this.$router.hideRoute("权限开通");

                params.BIZ_DATA.AGMT_LIST = [];
              } else {
                _this.$router.showRoute("权限开通");
              }

              _.set(params, SAVE_PATH, TRDACCT_INFO_LIST || []);

              if (!(_this.busiCode === "QS420")) {
                _context3.next = 36;
                break;
              }

              if (_.isEmpty(TRDACCT_INFO_LIST)) {
                _context3.next = 34;
                break;
              }

              _context3.next = 29;
              return getCsdcChangeFlag(_this, params);

            case 29:
              csdcData = _context3.sent;

              params.BIZ_DATA.IS_CHANGE_CSDC_FLAG = csdcData.isChangeCSDCFlag;
              params.IMG_DATA.CHANGE_CSDC_INFO_LIST = csdcData.changeCSDCData;
              _context3.next = 36;
              break;

            case 34:
              params.BIZ_DATA.IS_CHANGE_CSDC_FLAG = "0";
              params.IMG_DATA.CHANGE_CSDC_INFO_LIST = [];

            case 36:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, this);
    }));

    function beforeSave(_x8, _x9, _x10) {
      return _ref7.apply(this, arguments);
    }

    return beforeSave;
  }(),

  validate: function () {
    var _ref8 = _asyncToGenerator(_regeneratorRuntime.mark(function _callee4(_this) {
      var trdacctArr, initProCls, flag, reqArr;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              trdacctArr = getTrdAcctInfo(_this);
              initProCls = _this.userType == "2" ? _this.groupDatas.PRODUCT_INFO_PAGE.BASE_INFO[0].FIELDS.PRO_CLS.DEFAULT_VALUE : "";
              flag = true;
              reqArr = [];

              if (!(trdacctArr.length > 1 && _this.oppBusiData.RISK_FACTOR.includes("o"))) {
                _context4.next = 7;
                break;
              }

              alert("再贷款回购增持股票专户仅允许开通一个市场的证券账户。");
              return _context4.abrupt("return", false);

            case 7:
              _.each(trdacctArr, function (obj) {
                if (obj.SEL_TYPE == "0" && obj.TRDACCT == "") {
                  flag = false;
                  alert("证券账户不能为空!");
                  return false;
                }

                if (_.isEmpty(obj.STKPBU) && initProCls && ["99b", "99c"].includes(initProCls)) {
                  flag = false;
                  alert("请输入交易单元!");
                  return false;
                }
                var newStockInfo = "";
                _.each(_this.groupDatas.ACCT_INFO.TRDACCT_MODULE[0].FIELDS.TRDACCT_INFOA.FIELD_DICT_NAME, function (tempObj) {
                  if (obj.OP_TYPE.includes(tempObj.OP_TYPE)) {
                    newStockInfo = tempObj;
                  }
                });
                if (!_.isEmpty(newStockInfo)) {
                  reqArr.push(validateNewOpen(_this, newStockInfo, newStockInfo.MARKET_NAME_SHORT, true));
                }
              });

              if (!flag) {
                _context4.next = 12;
                break;
              }

              _context4.next = 11;
              return _Promise.all(reqArr).then(function (resArr) {
                var resFlag = true;
                _.each(resArr, function (item) {
                  if (!item) {
                    resFlag = false;
                  }
                });
                return resFlag;
              });

            case 11:
              flag = _context4.sent;

            case 12:
              return _context4.abrupt("return", flag);

            case 13:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, this);
    }));

    function validate(_x11) {
      return _ref8.apply(this, arguments);
    }

    return validate;
  }(),

  pageActivated: function () {
    var _ref9 = _asyncToGenerator(_regeneratorRuntime.mark(function _callee5(_this, groupId) {
      var flag, busiInfo, custInfo, SZORGTYPE, properRiskSurveyLvl, RATING_LVL, RATING_LVL_NAME, trdacctInfoList, PRO_CLS, stkpubFlag, arr;
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _this.removeFlowTip("allowB");
              _this.removeFlowTip("key1");
              _this.removeFlowTip("key2");
              _context5.prev = 3;

              _this.$store.commit(_this.$types.UPDATE_LOADING, "正在更新数据...");
              _context5.next = 7;
              return oppService.mergeMobileData();

            case 7:
              flag = _context5.sent;

              if (flag) {
                busiInfo = this.$storage.getJsonSession(this.$definecfg.BUSI_INFO);

                this.historyData = _Object$assign(this.historyData, busiInfo);
                consoleLog("biztrd 合并手机数据成功，更新historydata");
              }
              _context5.next = 15;
              break;

            case 11:
              _context5.prev = 11;
              _context5.t0 = _context5["catch"](3);

              vm.$store.commit(vm.$types.UPDATE_LOADING, false);
              consoleError("biztrd 合并手机数据失败", _context5.t0);

            case 15:
              vm.$store.commit(vm.$types.UPDATE_LOADING, false);

              custInfo = _this.$storage.getJsonSession(_this.$definecfg.CUSTOMER_INFO) || {};
              SZORGTYPE = "";

              if (_this.userType == "1") {
                SZORGTYPE = _this.groupDatas.ORG_INFO_PAGE.BASIC_MODULE[0].FIELDS.SZORG_TYPE.DEFAULT_VALUE;
              } else {
                SZORGTYPE = _this.groupDatas.MANAGER_INFO_PAGE.MANAGER_OTHER_INFO[0].FIELDS.SZORG_TYPE.DEFAULT_VALUE;
              }

              _this.oppBusiData.RISK_FACTOR = _this.userType != "2" ? _this.groupDatas.ORG_INFO_PAGE.BASIC_MODULE[0].FIELDS.RISK_FACTOR.DEFAULT_VALUE : "";

              _this.oppBusiData.isAllowOpenB = !_this.oppBusiData.RISK_FACTOR.includes("o") && _this.userType != "2" && custInfo.ID_TYPE == "14" && ["10", "11", "12", "13", "14", "33", "34", "41", "15", "51", "52", "99a"].indexOf(SZORGTYPE) == -1;
              _this.oppBusiData.SZORGTYPE = SZORGTYPE;
              properRiskSurveyLvl = oppService.getBusiCommonParamsFromCacheObjs("PROPER_RISK_SURVEY_LVL");

              _this.oppBusiData.checkTrdacctObj = _.get(_this, "historyData.DETAIL_DATA.checkTrdacctObj") || {};
              if (!_.isEmpty(_this.oppBusiData.checkTrdacctObj)) {
                _this.groupDatas.ACCT_INFO.ASSET_MODULE[0].FIELDS.POSITION_REMARK.DEFAULT_VALUE = "";
                _this.groupDatas.ACCT_INFO.ASSET_MODULE[0].FIELDS.POSITION_REMARK.FIELD_CONTROL = "1";
              } else {
                _this.groupDatas.ACCT_INFO.ASSET_MODULE[0].FIELDS.POSITION_REMARK.FIELD_CONTROL = "0";
              }
              if (_this.oppBusiData.isAllowOpenB) {
                _this.pushFlowTip({
                  title: "14-境外有效商业登记证明文件不允许开立A股、深基金、沪基金账户，可开立B股账户",
                  key: "allowB",
                  type: "warning"
                });
              }
              _this.oppBusiData.isAllowOpenA = _this.userType == "2" || custInfo.ID_TYPE == "14" && ["10", "11", "12", "13", "14", "33", "34", "41", "15", "51", "52", "99a"].indexOf(SZORGTYPE) != -1 || custInfo.ID_TYPE != "14";
              if (_this.oppBusiData.MECHANISM_PRO_INVESTORS_I.indexOf(SZORGTYPE) !== -1 || _this.userType == "2") {
                _this.oppBusiData.PROF_INVESTOR_SOURCE = "10";
              } else {
                _this.oppBusiData.PROF_INVESTOR_SOURCE = "00";
              }

              if (_this.userType != "2" && _this.oppBusiData.ENABLE_OPEN_ACCT_MATCH_RESULT == "1" && _this.oppBusiData.PROF_INVESTOR_SOURCE == "00") {

                _this.pushFlowTip({
                  title: "开立证券账户的适当性要求为稳健型及以上，若风险等级不满足要求，将不允许开立证券账户。",
                  key: "bizSuryRisk",
                  type: "warning"
                });
              }
              RATING_LVL = _.get(_this.historyData, "BIZ_DATA.PROPER_DATA.RATING_LVL", "");
              RATING_LVL_NAME = _.get(_this.historyData, "BIZ_DATA.PROPER_DATA.RATING_LVL_NAME", "");

              if (_this.userType != "2" && _this.oppBusiData.ENABLE_OPEN_ACCT_MATCH_RESULT == "1" && _this.oppBusiData.PROF_INVESTOR_SOURCE == "00" && RATING_LVL != "" && RATING_LVL < properRiskSurveyLvl) {
                _this.oppBusiData.isDisableAllStock = true;
                _this.oppBusiData.checkTrdacctObj = {};
                _this.pushFlowTip({
                  title: "客户的风险等级为" + RATING_LVL_NAME + "，不满足开立证券账户的适当性管理要求，不允许开立证券账户。",
                  key: "bizSuryRisk2",
                  type: "warning"
                });
              } else {
                _this.oppBusiData.isDisableAllStock = false;
              }
              if (_this.userType == "1") {
                _this.oppBusiData.specialOrg = ["15", "51", "52"].indexOf(SZORGTYPE) != -1;
              }
              if (_this.oppBusiData.specialOrg) {
                _this.pushFlowTip({
                  title: "该客户为特殊机构客户，不允许新开立证券账户，可加挂证券账户，如需开立请客户携带相关资料前往中登公司开立证券账户！",
                  key: "forbinOpen",
                  type: "warning"
                });
              }

              trdacctInfoList = _.get(_this, "historyData.BIZ_DATA.TRDACCT_INFO_LIST", []);

              if (_this.userType == "2") {
                PRO_CLS = _this.groupDatas.PRODUCT_INFO_PAGE.BASE_INFO[0].FIELDS.PRO_CLS.DEFAULT_VALUE;
                stkpubFlag = ["23", "23a", "23b", "23c", "23d", "23e", "23f", "01", "99b", "99c"].indexOf(PRO_CLS) != -1 ? "1" : "0";

                _this.groupDatas.ACCT_INFO.TRDACCT_MODULE[0].FIELDS.TRDACCT_INFOA.ALLOW_INPUT_STKPBU = stkpubFlag;

                if (!_.isEmpty(trdacctInfoList)) {
                  _this.groupDatas.ACCT_INFO.TRDACCT_MODULE[0].FIELDS.OA_NUM.FIELD_CONTROL = "0";
                }
              }

              arr = _.filter(trdacctInfoList, function (v) {
                return v.SEL_TYPE == "1";
              });

              if (!_.isEmpty(arr) && (_this.openAcctType == "2" || _this.openAcctType === "3")) {
                _this.pushFlowTip({
                  title: "请告知客户，券商会根据客户柜台留存信息在PROP平台为其开立中登证券账户！",
                  key: "proptrd",
                  type: "warning"
                });
              } else {
                _this.removeFlowTip("proptrd");
              }

              return _context5.abrupt("return", queryCSDC(_this));

            case 39:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, this, [[3, 11]]);
    }));

    function pageActivated(_x12, _x13) {
      return _ref9.apply(this, arguments);
    }

    return pageActivated;
  }(),
  afterSave: function afterSave(_this, newData) {},
  beforeSkipBiz: function beforeSkipBiz(_this) {},
  CHECK_SUBJECT_IDENTITY: function CHECK_SUBJECT_IDENTITY(_this, field, fields) {},
  CHECK_NATIVE_PLACE: function CHECK_NATIVE_PLACE(_this, field, fields) {},

  "CHECK_TRDACCT_INFOA": function CHECK_TRDACCT_INFOA(_this, field, fieldDatas) {},
  "CHECK_TRDACCT_INFOA__CLICK": function () {
    var _ref10 = _asyncToGenerator(_regeneratorRuntime.mark(function _callee6(_this, field, fieldData) {
      var newStockInfo, proCls, tempTrdacct, validateTrdacct, currDictItem, stkbd, customerInfo, _tempArr;

      return _regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              newStockInfo = field.NEW_STOCK_INFO || {};
              proCls = _this.userType == "1" ? "" : _this.groupDatas.PRODUCT_INFO_PAGE.BASE_INFO[0].FIELDS.PRO_CLS.DEFAULT_VALUE;

              if (!_.isEmpty(newStockInfo)) {
                _context6.next = 4;
                break;
              }

              return _context6.abrupt("return");

            case 4:
              if (!(newStockInfo.SEL_TYPE == "0" && newStockInfo.TRDACCT && _.isEmpty(newStockInfo.TRDACCT_LIST))) {
                _context6.next = 10;
                break;
              }

              tempTrdacct = newStockInfo.TRDACCT;
              validateTrdacct = validateRules["numchar"].valid(tempTrdacct, [10, 10]);

              if (validateTrdacct) {
                _context6.next = 10;
                break;
              }

              alert("请输入10位长度的数字或英文字符");
              return _context6.abrupt("return");

            case 10:
              currDictItem = _.find(field.FIELD_DICT_NAME, function (value) {
                return value.DICT_ITEM == newStockInfo.value;
              });

              _Object$assign(currDictItem, newStockInfo);

              if (!(newStockInfo.stkpbuOrTrdacctFlag == "1")) {
                _context6.next = 22;
                break;
              }

              if (!(newStockInfo.SEL_TYPE !== "" && newStockInfo.STKPBU !== "" && !_.isEmpty(proCls) && ["99b", "99c"].includes(proCls))) {
                _context6.next = 20;
                break;
              }

              stkbd = _.get(_.find(field.FIELD_DICT_NAME, function (v) {
                return v.DICT_ITEM === newStockInfo.value;
              }), "STKBD");

              _this.myLoading({

                loadingText: "正在校验交易单元",
                autoHide: false
              });
              customerInfo = _this.$storage.getJsonSession(_this.$definecfg.CUSTOMER_INFO);
              return _context6.abrupt("return", _this.$syscfg.K_Request("F0000000", {
                SERVICE_CODE: "QS200057",
                INT_ORG: customerInfo.INT_ORG,
                STKBD: stkbd
              }, true).then(function (res) {
                var stkpbuArr = _.pluck(_.get(res, "Data", []), "STKPBU") || [];
                if (!stkpbuArr.includes(newStockInfo.STKPBU)) {
                  currDictItem.STKPBU = "";
                  _this.alert("请输入客户所属机构的交易单元！");
                }
                saveTrdacctObj(_this, newStockInfo);
              }).catch(function (err) {
                consoleLog("校验交易单元err", err);
              }).finally(function () {
                _this.myLoading({
                  showLoading: false
                });
              }));

            case 20:
              _context6.next = 53;
              break;

            case 22:
              if (!(newStockInfo.SEL_TYPE == "")) {
                _context6.next = 27;
                break;
              }

              removeTrdacctObj(_this, newStockInfo);
              _this.removeFlowTip("proptrd");
              _context6.next = 49;
              break;

            case 27:
              if (!(newStockInfo.SEL_TYPE == "1")) {
                _context6.next = 38;
                break;
              }

              _context6.next = 30;
              return validateNewOpen(_this, newStockInfo, currDictItem.DICT_ITEM_NAME, false);

            case 30:
              if (!_context6.sent) {
                _context6.next = 34;
                break;
              }

              saveTrdacctObj(_this, newStockInfo);
              _context6.next = 36;
              break;

            case 34:
              removeTrdacctObj(_this, newStockInfo);
              currDictItem.SEL_TYPE = "";

            case 36:
              _context6.next = 49;
              break;

            case 38:
              if (!(newStockInfo.SEL_TYPE == "0" && newStockInfo.TRDACCT == "")) {
                _context6.next = 43;
                break;
              }

              removeTrdacctObj(_this, newStockInfo);
              saveTrdacctObj(_this, newStockInfo);
              _context6.next = 49;
              break;

            case 43:
              if (!(newStockInfo.SEL_TYPE == "0" && newStockInfo.TRDACCT != "")) {
                _context6.next = 49;
                break;
              }

              removeTrdacctObj(_this, newStockInfo);
              saveTrdacctObj(_this, newStockInfo);

              if (!(_this.oppBusiData.isCsdcTime == "true" && ["11", "12", "13"].includes(newStockInfo.value))) {
                _context6.next = 49;
                break;
              }

              _this.myLoading({
                loadingText: "正在查询中登指定信息",
                autoHide: false
              });
              return _context6.abrupt("return", _this.$syscfg.K_Request("F0000000", {
                SERVICE_CODE: "Y3000404",
                TRDACCT: newStockInfo.TRDACCT,
                ACCT_TYPE: newStockInfo.value
              }, true, true).then(function (res) {
                if (res && res.Code == "0" && res.Data && res.Data[0] && res.Data[0].FIR_ORG_NAME && res.Data[0].FIR_ORG_NAME != "") {
                  _this.alert("警示：此加挂证券账号" + newStockInfo.TRDACCT + "处于已指定状态，为了不影响正常交易，需要先撤销原指定交易委托！");
                }
                return;
              }).catch(function (err) {
                consoleError(err);
              }).finally(function () {
                _this.myLoading({
                  showLoading: false
                });
              }));

            case 49:
              if (!_.isEmpty(_this.oppBusiData.checkTrdacctObj)) {
                _this.groupDatas.ACCT_INFO.ASSET_MODULE[0].FIELDS.POSITION_REMARK.DEFAULT_VALUE = "";
                _this.groupDatas.ACCT_INFO.ASSET_MODULE[0].FIELDS.POSITION_REMARK.FIELD_CONTROL = "1";
                if (_this.userType == "2") {
                  _this.groupDatas.ACCT_INFO.TRDACCT_MODULE[0].FIELDS.OA_NUM.FIELD_CONTROL = "0";
                }
              } else {
                _this.groupDatas.ACCT_INFO.ASSET_MODULE[0].FIELDS.POSITION_REMARK.FIELD_CONTROL = "0";
                if (_this.userType == "2") {
                  _this.groupDatas.ACCT_INFO.TRDACCT_MODULE[0].FIELDS.OA_NUM.FIELD_CONTROL = "1";
                }
              }

              _tempArr = [];

              _.each(_this.oppBusiData.checkTrdacctObj, function (obj, key) {
                obj.SEL_TYPE == "1" && _tempArr.push(obj);
              });

              if (_.isEmpty(_tempArr)) {
                _this.removeFlowTip("proptrd");
              }

            case 53:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, _this2);
    }));

    return function CHECK_TRDACCT_INFOA__CLICK(_x14, _x15, _x16) {
      return _ref10.apply(this, arguments);
    };
  }(),
  queryModule: function queryModule(_this, fieldData) {
    return queryCSDC(_this, true);
  },
  CHECK_IS_OPEN_FINANCIAL_FUTURES: function CHECK_IS_OPEN_FINANCIAL_FUTURES(_this, field, fieldData) {
    if (field.DEFAULT_VALUE == "1") {
      fieldData.FINANCIAL_FUTURES_NUM.FIELD_CONTROL = "0";
    } else {
      fieldData.FINANCIAL_FUTURES_NUM.FIELD_CONTROL = "1";
      fieldData.FINANCIAL_FUTURES_NUM.DEFAULT_VALUE = "";
    }
  }
};

export default NODE;


//////////////////
// WEBPACK FOOTER
// ./src/business/businessFile/QS420/bizAcct/bizTrdAcctInfoNode.js
// module id = 163
// module chunks = 2